
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.418 5.75a15.882 15.882 0 0117.923 0l8.629 5.897-7.03 4.806c-.329-1.838-1.136-3.665-2.67-4.97-2.362-2.01-5.49-2.014-8.49-.582-1.715.818-2.899 2.08-3.59 3.634-.642 1.444-.783 2.972-.794 4.269-.004.483.01.984.035 1.484l-12.642-8.64 8.629-5.898zm17.058 19.97l15.041-10.281 18.47 12.624a3.53 3.53 0 011.537 2.914v28.928c0 5.238-2.587 10.14-6.913 13.097l-9.963 6.81V43.277a3.13 3.13 0 00-1.364-2.585l-18.772-12.83a13.586 13.586 0 001.964-2.142zm11.91 19.209V84.09L52.372 96.405a3.53 3.53 0 01-3.983 0L30.372 84.09V44.929l16.712-11.423c.955-.449 1.898-1.048 2.695-1.842l.6-.41 20.008 13.675zm-46.275-1.652v36.535l-9.962-6.81a15.851 15.851 0 01-6.914-13.09V30.977a3.53 3.53 0 011.538-2.914l18.469-12.624 7.137 4.878a7.476 7.476 0 00-2.75 2.057c-1.14 1.377-1.718 3.123-1.718 5.088 0 2.176 1.04 3.893 2.453 5.056.839.69 1.806 1.192 2.801 1.55l-9.69 6.624a3.13 3.13 0 00-1.364 2.585zm16.187-17.03c.948.563 2.243 1.205 3.571 1.82-1.612.583-3.832.749-5.65.37-.977-.203-1.898-.1-2.047-.973-.075-.435.187-.984.279-1.095.117-.142.355-.326.82-.453.471-.13 1.065-.165 1.676-.084.622.082 1.096.263 1.351.415zm14.56-7.732c0 .52-.253 1.578-.916 2.72-.663 1.143-2.08 1.422-2.08 1.422a81.555 81.555 0 00-.082-1.191c-.071-1.005-.13-1.83-.123-2.609.008-.958.123-1.484.254-1.778.082-.185.19-.348.565-.527.775-.37 1.241-.41 1.448-.399.17.01.234.052.29.099.194.166.644.84.644 2.263z","fill":"#fff"}})])
          )
        }
      }
    